import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Building2, BadgeCheck, MapPin, Package } from "lucide-react";
import { LoadingState, EmptyState } from "@/components/States";
import api from "@/lib/api";

export default function CorporateSellers() {
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/corporate-sellers").then(({ data }) => setSellers(data.items)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-6 py-10">
      <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900">Onaylı Kurumsal Satıcılar</h1>
      <p className="mt-1 text-slate-500">Çöpcepte tarafından doğrulanmış firma hesapları</p>

      {loading ? <LoadingState /> : sellers.length === 0 ? (
        <div className="mt-8"><EmptyState title="Henüz onaylı kurumsal satıcı yok" icon={Building2} /></div>
      ) : (
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {sellers.map((s) => (
            <Link key={s.user_id} to={`/ilanlar?seller_type=kurumsal`} data-testid={`corporate-${s.user_id}`}
              className="rounded-xl border border-slate-200 bg-white p-6 transition-all hover:shadow-md hover:-translate-y-0.5">
              <div className="flex items-start gap-3">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-50 text-emerald-700"><Building2 /></span>
                <div className="min-w-0">
                  <div className="flex items-center gap-1.5">
                    <h3 className="truncate font-display text-lg font-bold text-slate-900">{s.name}</h3>
                    <BadgeCheck size={18} className="shrink-0 text-emerald-500" />
                  </div>
                  <p className="text-xs font-medium text-emerald-600">Onaylı Kurumsal Satıcı</p>
                </div>
              </div>
              {s.company?.company_description && <p className="mt-3 line-clamp-2 text-sm text-slate-600">{s.company.company_description}</p>}
              <div className="mt-4 flex items-center justify-between text-sm text-slate-500">
                <span className="flex items-center gap-1"><MapPin size={14} />{s.city || "—"}</span>
                <span className="flex items-center gap-1 font-semibold text-slate-700"><Package size={14} />{s.active_listings} aktif ilan</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
